import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=4865efac&scoped=true&"
import script from "./Identification.vue?vue&type=script&lang=js&"
export * from "./Identification.vue?vue&type=script&lang=js&"
import style0 from "./Identification.vue?vue&type=style&index=0&id=4865efac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865efac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VSubheader})
